<template>
  <button
    class="duration-250 generated-3"
    :disabled="disabled"
  >
    <slot />
  </button>
</template>

<script lang="ts" setup>
interface Props {
  disabled?: boolean
}
const props = withDefaults(defineProps<Props>(), {
  disabled: false,
})
</script>
<style lang="scss" scoped>
@use '@/assets/styles/scss/vue' as *;

.generated-3 {
    border-radius: 0.25rem;
    background-color: transparent;
    color: $jps-key-blue;
    @include transition-all;
    &:hover {
        color: $jps-key-blue-hover;
        text-decoration-line: underline;
    }
    &:disabled { opacity: 0.5; }
}
</style>